
import BaseMixin from '@/views/mixin.vue'
import { mapState, mapGetters } from 'vuex'
import { HttpSaTemplateList, HttpDelSaTemplate } from '@/service/boss/allot';

import compSearch from './search';
import compDetail from './detail';
import compSku from './sku';

import { Dropdown, Icon, Button } from 'view-design'


export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compDetail,
        compSku,
    },
    data () {
        return {
            data: [],
            checkedId: [],
        };
    },
    methods: {
        httpList: HttpSaTemplateList,
        handleOperates (id, type, row) {
            this.operate = {};
            switch (type) {
                case 'delete':
                    this.showDel = true;
                    this.operate = {
                        id,
                        type,
                        title: this.$t('fbb.accountmanage.operate_loss_effect',{defaultValue:'失效操作'}),
                        desc: this.$t('erp.virtualstore.inactivedesc',{defaultValue:'失效后若无新模板替代，对应的ERP SKU将无法计算库存分配，请谨慎操作！'})
                    }; break;
                case 'query':
                    this.operate = {
                        id,
                        title: this.$t('global.common.query',{defaultValue:'查看'}),
                        show: true,
                        component: "compDetail",
                        width: 1000,
                    }; break;
                case 'add':
                    this.$router.push({ name: 'saTemplateDetail', params: { type: 'add' } }); break;
                case 'edit':
                    this.$router.push({ name: 'saTemplateDetail', params: { type: 'edit' }, query: { id } }); break;
                case 'sku':
                    this.operate = {
                        id,
                        title: this.$t('erp.virtualstore.copysku',{defaultValue:'复制到其他SKU'}),
                        component: 'compSku',
                        show: true,
                        width: 760
                    }; break;
                case 'upload':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.b2corder.import_template',{defaultValue:'导入模板'}),
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTemplate/import",
                        name: "excelFile",
                        component: "compUpload",
                        showdownload: false,
                        download: this.download,
                        refresh: this.updateList,
                        showcontent: true,
                        contenttext: this.$t('erp.virtualstore.uploaddesc',{defaultValue:'此功能仅支持更新数据，不支持新增。建议先导出需要修改的数据，再进行导入。'}),
                    }
                    break;
                case 'export':
                    this.checkedId = !id ? this.checkedId : [id];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
                        return;
                    }
                    // 调用导出方法，传相对应的id
                    this.exportFile(this.checkedId)
                    break;
            }
        },
        download () {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTransfer/excel", {}, 'download')
        },
        exportFile (ids) {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/StockTemplate/export", { ids: ids }, 'download')
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'delete': request = HttpDelSaTemplate; params = { id: this.checkedId.join(',') || id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewDifferentAllProductList']),
        columns () {
            return [
                {
                    type: 'selection',
                    width: 60,
                },
                {
                    title: this.$t('global.common.operate',{defaultValue:'操作'}),
                    width: 95,
                    render: (h, { row }) => {
                        const id = row.id, show = row.status !== 'INACTIVE';
                        return <Dropdown placement="bottom-start" trigger="click">
                            <Button size='small' type='info'>{this.$t('global.common.operate',{defaultValue:'操作'})} <Icon type="md-arrow-dropdown" /></Button>
                            <DropdownMenu slot="list" class="text-left">
                                <DropdownItem class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'query')}>{this.$t('global.common.query',{defaultValue:'查看'})}</DropdownItem>
                                <DropdownItem v-show={show} class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'edit')}>{this.$t('global.common.edit',{defaultValue:'编辑'})}</DropdownItem>
                                <DropdownItem v-show={show} class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'delete')}>{this.$t('global.common.failure',{defaultValue:'失效'})}</DropdownItem>
                                <DropdownItem v-show={show} class='splitline' nativeOnClick={this.handleOperates.bind(this, id, 'sku')}>{this.$t('global.common.copy',{defaultValue:'复制'})}</DropdownItem>
                            </DropdownMenu>
                        </Dropdown >
                    }
                },
                {
                    title: '#ID',
                    width: 80,
                    key: 'id',
                    sortable: true,
                },

                {
                    title: this.$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'}),
                    key: 'templateName',
                    maxWidth: 140,
                    render: (h, { row }) => {
                        return <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.templateName}</a>
                    }
                },

                {
                    title: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'lineId',
                    sortable: true,
                    render: (h, { row }) => {
                        const id = row.lineId;
                        const product = this.getNewDifferentAllProductList.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <span>{product.label}</span>
                    },
                },

                {
                    title: 'ERP SKU',
                    key: 'erpSku',
                    sortable: true,
                },
                {
                    title: this.$t('erp.virtualstore.description',{defaultValue:'模板描述'}),
                    key: 'description',
                    sortable: true,
                },
                {
                    title: this.$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'}),
                    key: 'stockVirtualGroupRuleEntity.name',
                    sortable: true,
                    render (h, { row }) {
                        return <span>{row.stockVirtualGroupRuleEntity ? row.stockVirtualGroupRuleEntity.name : '--'}</span>
                    }

                },
                {
                    title: this.$t('fbb.adjustment.created_name',{defaultValue:'创建人'}),
                    key: 'createdName',
                    sortable: true,
                }, {
                    title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
                    key: "createdAt",
                },
                // {
                //     title: "更新时间", 
                //     key: "updatedAt",

                // },
                {
                    title: this.$t('erp.virtualstore.tempstatus',{defaultValue:'模板状态'}),
                    key: 'status',
                    width: 105,
                    sortable: true,
                    render: (h, { row }) => {
                        const status = row.status;
                        return status == 'ACTIVE' ? <Button class="cursor-default" type='success' size='small'>{this.$t('global.common.effective',{defaultValue:'有效'})}</Button> : <Button class="cursor-default" type='error' size='small'>{this.$t('global.common.failure',{defaultValue:'失效'})}</Button>
                    }
                }];
        },
    },
};




